module.exports = __webpack_public_path__ + "img/4.c602824a.png";